import { render, staticRenderFns } from "./addOrEditTemplate.vue?vue&type=template&id=16beabc5&scoped=true&"
import script from "./addOrEditTemplate.vue?vue&type=script&lang=js&"
export * from "./addOrEditTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditTemplate.vue?vue&type=style&index=0&id=16beabc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16beabc5",
  null
  
)

export default component.exports